document.addEventListener('DOMContentLoaded', function () {
  const contentDisplays = document.querySelectorAll('.product-popup-modal__content-info');
  let contentFound = false;

  if (
    typeof productSizechartGid !== 'undefined' &&
    productSizechartGid &&
    productSizechartGid !== 'none'
  ) {
    const pageId = String(productSizechartGid).split('/').pop();
    fetchPageContent(pageId, contentDisplays);
    contentFound = true;
  }

  if (!contentFound) {
    document.querySelectorAll('.product-popup-modal__opener').forEach(function (element) {
      element.style.display = 'none';
    });
  }

  function fetchPageContent(pageId, displays) {
    fetch('https://' + Shopify.shop + '/api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.storefrontAccessToken,
      },
      body: JSON.stringify({
        query:
          'query { page(id: "gid://shopify/Page/' +
          pageId +
          '") { title handle body } }',
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var pageContent = data.data && data.data.page ? data.data.page.body : null;
        if (pageContent) {
          displays.forEach(function (contentDisplay) {
            contentDisplay.innerHTML = pageContent;
          });
        } else {
          displays.forEach(function (contentDisplay) {
            contentDisplay.innerHTML = 'Page content not available.';
          });
        }
      })
      .catch(function (error) {
        console.error('Error fetching page content:', error);
        displays.forEach(function (contentDisplay) {
          contentDisplay.innerHTML = 'Failed to load page content.';
        });
      });
  }
});
